var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{staticClass:"header__page"},[_c('h1',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }